var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export function XBox(_a) {
    var className = _a.className, padding = _a.padding, gap = _a.gap, rounded = _a.rounded, layer = _a.layer, fullHeight = _a.fullHeight, fullWidth = _a.fullWidth, flex = _a.flex, flexChildren = _a.flexChildren, align = _a.align, justify = _a.justify, textAlign = _a.textAlign, fontSize = _a.fontSize, rest = __rest(_a, ["className", "padding", "gap", "rounded", "layer", "fullHeight", "fullWidth", "flex", "flexChildren", "align", "justify", "textAlign", "fontSize"]);
    if (flexChildren || align || justify) {
        flex = true;
    }
    if (flex && !align) {
        align = 'center';
    }
    return (React.createElement("div", __assign({}, rest, { className: clsx(className, "XBox", "x-padding-" + padding + " fontSize-" + (fontSize !== null && fontSize !== void 0 ? fontSize : '') + " x-gap-" + (gap || '') + " align-" + (align || '') + " justify-" + (justify || '') + " textAlign-" + (textAlign || ''), {
            flexChildren: flexChildren,
            rounded: rounded,
            layer: layer,
            flex: flex,
            fullHeight: fullHeight,
            fullWidth: fullWidth,
        }) })));
}
